module.exports = __webpack_public_path__ + "static/mission-df06bbab62819195fcb9b1747bf599fc.jpg";